import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "cerrix-button",
    imports: [MatIcon],
    templateUrl: "./cerrix-button.component.html",
    styleUrl: "./cerrix-button.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixButtonComponent {
    @Input() text?: string;
    @Input() resultText?: string;
    @Input() icon?: string;
    @Input() iconPosition: "left" | "right" | "both" = "left";
    @Input() buttonType: "primary" | "secondary" = "primary";
    @Input() primaryColor: "blue" | "green" | "red" | "yellow" = "blue";
    @Input() secondaryColor: "outlined" | "outlined-gray" | "filled" | "filled-blue" = "outlined";
    @Input() buttonSize: "big" | "medium" | "small" = "medium";
    @Input() public waitingOnResult: boolean = false;
    @Input() public showResultText: boolean = false;
    @Input() disabled: boolean = false;

    public get buttonClass(): string {
        return `cerrix-btn-${this.buttonType} cerrix-btn-${this.buttonSize} ${
            this.buttonType === "primary"
                ? `cerrix-btn-${this.primaryColor}`
                : `cerrix-btn-${this.secondaryColor}`
        }`;
    }
}
